<template>
  <div class="check-code">
    <div class="check-code__status">
      <!-- 加载中 -->
      <div v-if="loading" class="check-code__loading">
        <van-loading type="spinner" vertical>查询中...</van-loading>
      </div>

      <!-- 查询成功 -->
      <div v-else-if="isExist" class="check-code__result">
        <!-- 商品图片
        <div class="check-code__image" v-if="codeInfo.productImage">
          <img :src="codeInfo.productImage" alt="商品图片" />
        </div> -->
        <div class="check-code__title">验证成功</div>
        <div class="check-code__desc">感谢您选择本品牌正品产品，请安心使用</div>
        <!-- 产品详情按钮 -->
        <div class="check-code__actions" v-if="codeInfo.productId">
          <button class="check-code__btn" @click="goProductDetail">继续</button>
        </div>

        <!-- 跳转微信小程序按钮
        <div class="check-code__actions" v-if="codeInfo.urlLink">
          <a
            class="check-code__btn"
            :href="codeInfo.urlLink"
            style="display: block; background: #07c160; text-decoration: none; color: #fff; box-sizing: border-box"
          >
            前往小程序
          </a>
        </div>
 -->
      </div>

      <!-- 查询失败/码不存在 -->
      <div v-else class="check-code__result">
        <div class="check-code__icon">
          <span class="iconfont icon-guanbi" style="color: #ed4014"></span>
        </div>
        <div class="check-code__title">商品信息不存在</div>
        <div class="check-code__desc">
          {{ errorMsg || "请检查溯源码是否正确" }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { parseQuery } from "@utils/index";
import {
  getTraceabilityCodeInfo,
  getProductTraceabilityInfo,
  generateUrlLink,
} from "@api/code";

export default {
  name: "CheckCode",
  data() {
    return {
      code: "",
      loading: true,
      isExist: false,
      errorMsg: "",
      codeInfo: {
        code: "",
        productCode: "",
        productId: null,
        productName: "",
        productImage: "",
        isShow: true,
        isVerify: false,
        createTime: "",
        verifyTime: "",
        urlLink: "",
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const query = parseQuery();
      const code = query.code;
      if (!code) {
        this.loading = false;
        this.isExist = false;
        this.errorMsg = "未获取到有效的溯源码";
        return;
      }
      this.code = code;
      this.fetchCodeInfo(code);
    },
    fetchCodeInfo(code) {
      this.loading = true;
      getTraceabilityCodeInfo(code)
        .then((res) => {
          this.loading = false;
          // 接口返回200说明码存在，商品信息在 res.data 中
          const data = res.data || res;
          this.setCodeInfo(data);
        })
        .catch((err) => {
          this.loading = false;
          // 后端返回格式为 { code: 200, data: {...} }，但 request 拦截器检查的是 status
          // 所以即使成功也可能走到 catch，需要从 err 中提取数据
          const data = (err && err.data) || {};
          if (data.code === 200 && data.data) {
            this.setCodeInfo(data.data);
          } else if (
            err &&
            err.res &&
            err.res.data &&
            err.res.data.code === 200
          ) {
            this.setCodeInfo(err.res.data.data);
          } else {
            this.isExist = false;
            this.errorMsg = (err && err.msg) || "商品信息不存在";
          }
        });
    },
    setCodeInfo(data) {
      if (!data || (!data.code && !data.productCode)) {
        this.isExist = false;
        this.errorMsg = "商品信息不存在";
        return;
      }
      this.codeInfo = {
        code: data.code || "",
        productCode: data.productCode || "",
        productId: data.productId || null,
        productName: data.productName || "",
        productImage: data.productImage || "",
        isShow: data.isShow !== undefined ? data.isShow : true,
        isVerify: !!data.isVerify,
        createTime: data.createTime || "",
        verifyTime: data.verifyTime || "",
        urlLink: "",
      };
      this.isExist = true;
      // 验证成功后预取小程序跳转链接
      this.fetchUrlLink();
    },
    fetchUrlLink() {
      generateUrlLink({ path: "pages/index/index", expireInterval: 30 })
        .then((res) => {
          const data = res.data || res;
          // 兼容两种返回: 直接是url字符串，或 { urlLink: "..." }
          const link = typeof data === "string" ? data : data.urlLink;
          this.codeInfo.urlLink = typeof link === "string" ? link : "";
        })
        .catch(() => {
          // 链接获取失败时隐藏小程序按钮
          this.codeInfo.urlLink = "";
        });
    },
    goHome() {
      this.$router.replace("/");
    },
    goProductDetail() {
      if (this.codeInfo.productId) {
        this.$router.push({
          name: "ProductTraceability",
          params: { id: this.codeInfo.productId },
          query: { code: this.codeInfo.code },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.check-code {
  min-height: 100vh;
  background-color: #fff;

  &__status {
    padding: 1.333rem 0.4rem 0.4rem;
  }

  &__loading {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 6rem;
  }

  &__result {
    text-align: center;
  }

  &__image {
    margin-bottom: 0.533rem;

    img {
      width: 3.2rem;
      height: 3.2rem;
      border-radius: 0.213rem;
      object-fit: cover;
    }
  }

  &__icon {
    margin-bottom: 0.4rem;

    .iconfont {
      font-size: 2.133rem;
    }
  }

  &__title {
    font-size: 0.48rem;
    color: #333;
    font-weight: bold;
    margin-bottom: 0.267rem;
  }

  &__desc {
    font-size: 0.347rem;
    color: #999;
    margin-bottom: 0.533rem;
  }

  &__info {
    background: #f8f8f8;
    border-radius: 0.213rem;
    padding: 0.4rem;
    margin: 0 0.4rem 0.8rem;
    text-align: left;

    .info-item {
      display: flex;
      justify-content: space-between;
      padding: 0.213rem 0;
      border-bottom: 1px solid #eee;

      &:last-child {
        border-bottom: none;
      }
    }

    .info-label {
      font-size: 0.347rem;
      color: #999;
    }

    .info-value {
      font-size: 0.347rem;
      color: #333;
      max-width: 60%;
      text-align: right;
      word-break: break-all;
    }
  }

  &__actions {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__btn {
    width: 80%;
    margin-bottom: 0.4rem;
  }
}
</style>
